
import RcDomainMap from "../../common/RcDomainMap.js";
import Asset from './Asset.js';

export default class AssetMap extends RcDomainMap {
  static MODEL_NAME = Asset.MODEL_NAME  + "Map";
  
  constructor(domain, data) {
    super(domain, data, AssetMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new AssetMap(this.domain, data);
  }

  assetMap() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isMap()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetGpsDevice() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isGpsDevice()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetFlatRate() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isFlatRate()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetSupport() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isSupport()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetTrackLocation() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isTrackLocation()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetTrackSleeper() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isTrackSleeper()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetTimesheets() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isTimesheets()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetInspections() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isInspections()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetVehicles() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isVehicles()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetChecklists() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isChecklist()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetChecklistForVehicles() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isChecklistsForVehicles()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetCompliance() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isCompliance()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetSso() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isSso()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetProfileUpdate() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isProfileUpdate()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetEquipmentInspections() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isEquipmentInspections()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetEquipment() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isEquipment()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetMessages() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isMessages()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetDivisions() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isDivisions()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  assetLabels() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isLabels()) {
        return asset;
      }
    }
    return new Asset(this.domain, {});
  }

  priceForTimesheets() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isTimesheets()) {
        var featurePrice = feature.price();
        var discount = asset.discount();
        var price = parseFloat(featurePrice) * parseFloat(discount);
        return featurePrice - price;
      }
    }
    return 0;
  }
  
  priceForInspections() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isInspections()) {
        var featurePrice = feature.price();
        var discount = asset.discount();
        var price = parseFloat(featurePrice) * parseFloat(discount);
        return featurePrice - price;
      }
    }
    return 0;
  }
  
  priceForVehicles() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isVehicles()) {
        var featurePrice = feature.price();
        var discount = asset.discount();
        var price = parseFloat(featurePrice) * parseFloat(discount);
        return featurePrice - price;
      }
    }
    return 0;
  }
  
  priceForEquipmentInspections() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isEquipmentInspections()) {
        var featurePrice = feature.price();
        var discount = asset.discount();
        var price = parseFloat(featurePrice) * parseFloat(discount);
        return featurePrice - price;
      }
    }
    return 0;
  }

  priceForEquipment() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var feature = asset.feature().find();
      if (feature.isEquipment()) {
        var featurePrice = feature.price();
        var discount = asset.discount();
        var price = parseFloat(featurePrice) * parseFloat(discount);
        return featurePrice - price;
      }
    }
    return 0;
  }

  findByFeature(feature) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var f = asset.feature().find();
      if (f.idEquals(feature)) {
        return asset;
      }
    }
    return new Asset(this.domain).withFeature(feature);
  }

  findByFeatureKey(featureKey) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var asset = new Asset(this.domain, this.get(key));
      var f = asset.feature().find();
      if (f.name().endsWith(featureKey)) {
        return asset;
      }
    }
    return new Asset(this.domain);
  }

  find() {
    var keys = this.keys();
    var found = new AssetMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.assets().findById(key);
      var item = new Asset(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }
  
}